import { render, staticRenderFns } from "./switch-btn.vue?vue&type=template&id=218b0db3&"
import script from "./switch-btn.vue?vue&type=script&lang=js&"
export * from "./switch-btn.vue?vue&type=script&lang=js&"
import style0 from "./switch-btn.vue?vue&type=style&index=0&id=218b0db3&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports